"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, transparent)",
  d: "M3 10.316a2.46 2.46 0 0 1 1.977-2.411l.886-.178a3 3 0 0 1 2.132.37l.792.475A3 3 0 0 0 10.331 9H15a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.755 5.092h-.693a2.6 2.6 0 0 0-2.6 2.6h-1.4a4 4 0 0 1 4-4h.693a3 3 0 0 1 1.732.55l.325.23a3 3 0 0 0 1.732.551H18a4 4 0 0 1 4 4v4.22a4 4 0 0 1-4 4v-1.4a2.6 2.6 0 0 0 2.6-2.6v-4.22a2.6 2.6 0 0 0-2.6-2.6h-4.456a4.4 4.4 0 0 1-2.54-.807l-.326-.23a1.6 1.6 0 0 0-.923-.294"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.693 8.157H6a2.6 2.6 0 0 0-2.6 2.6v5.55a2.6 2.6 0 0 0 2.6 2.6h8.938a2.6 2.6 0 0 0 2.6-2.6v-4.219a2.6 2.6 0 0 0-2.6-2.6h-4.456a4.4 4.4 0 0 1-2.54-.807l-.326-.23a1.6 1.6 0 0 0-.923-.294M6 6.757h.692a3 3 0 0 1 1.733.55l.324.23a3 3 0 0 0 1.733.551h4.456a4 4 0 0 1 4 4v4.22a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4v-5.55a4 4 0 0 1 4-4",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.067 12.798a1.307 1.307 0 1 0 2.613 0 1.307 1.307 0 0 0-2.613 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.293 16.588c0-.962.78-1.742 1.742-1.742h1.089c.962 0 1.742.78 1.742 1.742 0 .24-.195.435-.435.435H6.729a.436.436 0 0 1-.436-.435m5.507.435h2.425c.24 0 .435-.195.435-.435 0-.963-.78-1.743-1.742-1.743H11.83q-.248 0-.477.066c.352.467.56 1.048.56 1.677 0 .2-.04.34-.111.435"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.48 17.021a.436.436 0 0 1-.393-.433c0-.417.146-.8.39-1.099.244.3.39.683.39 1.1 0 .223-.17.408-.387.432"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.271 12.798a1.307 1.307 0 1 0 2.613 0 1.307 1.307 0 0 0-2.613 0",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ProjectIcon24.js.map